export const priceFieldName = id => `price_${id}`

export const FIELD_DISABLED_PEOPLE = 'disabledPeople'
export const FIELD_PETS_ALLOWED = 'petsAllowed'
export const FIELD_PARKING = 'parking'
export const FIELD_POOL = 'pool'
export const FIELD_SPORTS_HALL = 'sportsHall'
export const FIELD_MEETING_ROOM = 'meetingRoom'
export const FIELD_AIR_CONDITIONER = 'airConditioner'

export const FIELD_BUSINESS = 'business'
export const FIELD_FAMILY = 'family'

export const BUTTON_OFF = '0'
export const BUTTON_ON = '1'
